export default "__VITE_ASSET__d1242ff6__"